"use client";

import { useEffect } from "react";
import { useFilters } from "@/_old/features/filters/context/filters";
import { useDashboardFilters } from "../../store/useDashboardFilters";
import { formatToISODate } from "@/core/utils/formatters";

export function DashboardFiltersBridge() {
  const { dateLimits, groupId } = useFilters();

  const setFilters = useDashboardFilters((s) => s.setFilters);

  useEffect(() => {
    const start = formatToISODate(dateLimits?.startDate as Date);
    const end = formatToISODate(dateLimits?.endDate as Date);

    setFilters({
      startDate: start,
      endDate: end,
      group_id: (groupId as number) ?? null,
    });
  }, [dateLimits?.startDate, dateLimits?.endDate, groupId, setFilters]);

  return null;
}
